import { PhysicalInventoryStatus, PhysicalInventoryPricingStatus } from "./physical-inventory-enums";

export class PhysicalInventoryDetails {
    public name: string = '';
    public id: string = '';
    public date: string = '';
    public status: PhysicalInventoryStatus = PhysicalInventoryStatus.processing;
    public pricingStatus: PhysicalInventoryPricingStatus = PhysicalInventoryPricingStatus.refreshing;  // to make it unclickable by default
    public controlGroups: PhysicalInventoryControlGroup[] = [];
}

export class PhysicalInventoryControlGroup {
    public serviceCenter: string = '';
    public controlNumber: string = '';
    public name: string = '';
    public entry1Status: PhysicalControlGroupStatus = PhysicalControlGroupStatus.notStarted;
    public entry2Status: PhysicalControlGroupStatus = PhysicalControlGroupStatus.notStarted;
    public hasConflicts: boolean = false;
    public layout: PhysicalControlGroupLayout = PhysicalControlGroupLayout.horizontal;
}

export enum PhysicalControlGroupStatus {
    notStarted = 0,
    inProgress = 1,
    complete = 2,
}

export enum PhysicalControlGroupLayout {
    horizontal = 0,
    vertical = 1,
}